import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import axios from "axios";
import mqtt from "mqtt/dist/mqtt";
import moment from "moment";

import utils from "@/store/modules/utils.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    abortController: null, // Almacenar el AbortController

    versionAcumulado:2,

    myAxios: axios.create({
      baseURL: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_BACK_HOST}:${process.env.VUE_APP_PORT}`,
      headers: {
        "Content-Type": "application/json",
        common: {
          Authorization: "Bearer " + localStorage.getItem("token") || null,
        },
      },
    }),

    myAxiosAcumulado: axios.create({
      baseURL: `${process.env.VUE_APP_PROTOCOL_ACUMULADO}://${process.env.VUE_APP_BACK_HOST_ACUMULADO}:${process.env.VUE_APP_PORT_ACUMULADO}`,
      headers: {
        "Content-Type": "application/json",
        common: {
          Authorization: "Bearer " + localStorage.getItem("token") || null,
        },
      },
    }),

    datos_maquina: {
      desmoldeo: [],
      macheria: [],
      moldeo: [],
      imf_nave_2: [],
      hornos1y2: [],
    },
    datos_parrillas_1: [],
    datos_parrillas_2: [],

    alarmasActivas: [],
    maquina: {},
    maquinas: [],
    graficoTiempoReal: false,
    datasetsParaGrafico: [
      {
        label: "",
        backgroundColor: "#da4726",
        borderColor: "#da4726",
        pointRadius: 0,
        borderWidth: 2,
        data: [],
      },
    ],
    labelsParaGrafico: [],
    tab: 0,
    user: {},
    fechaInicio: "",
    pieza: null,
    piezasMaquina: [],
    fechaFin: "",
    variableEnGrafica: null,
    ultima_lectura_desmoldeo: null,
    ultima_lectura_macheria: null,
    ultima_lectura_moldeo: null,
    ultima_lectura_imf_nave_2: null,
    ultima_lectura_hornos1y2: null,
    connection: {
      clean: true, // Reserved session
      connectTimeout: 4000, // Time out
      reconnectPeriod: 4000, // Reconnection interval
    },
    client: {
      connected: false,
    },
    subscription: {
      topic: "",
      qos: 0,
    },
  },
  getters: {
    getMachine(state) {
      return state.maquina;
    },
    getMaquinas(state) {
      return state.maquinas;
    },
    getVariables(state) {
      return state.variables;
    },
    getPiezasMaquina(state) {
      return state.piezasMaquina;
    },

    getInicio(state) {
      return state.fechaInicio;
    },
    getFin(state) {
      return state.fechaFin;
    },
  },
  mutations: {
    SET_ABORT_CONTROLLER(state, controller) {
      state.abortController = controller;
    },
  },
  actions: {
    setUpInterceptors({ state }) {
      state.myAxios.interceptors.request.use(
        function (config) {
          let token = localStorage.getItem("token");
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
          }
          return config;
        },
        function (err) {
          return Promise.reject(err);
        }
      );
      state.myAxios.interceptors.response.use(
        (response) => {
          // If the response status is between 200 and 299, it's a successful response, so return it as is.
          return response;
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            if (router.currentRoute.name != "login") this.dispatch("logout");
          }
        }
      );



      state.myAxiosAcumulado.interceptors.request.use(
        function (config) {
          let token = localStorage.getItem("token");
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
          }
          return config;
        },
        function (err) {
          return Promise.reject(err);
        }
      );
      state.myAxiosAcumulado.interceptors.response.use(
        (response) => {
          // If the response status is between 200 and 299, it's a successful response, so return it as is.
          return response;
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            if (router.currentRoute.name != "login") this.dispatch("logout");
          }
        }
      );
    },
    setUser({ state }, user) {
      state.user = user;
      localStorage.setItem("user", user);
    },
    setToken({ state }, token) {
      localStorage.setItem("token", token);
    },

    //    LOGIN & LOGOUT
    async login({ state }, userInfo) {
      try {
        const res = await state.myAxios.post("auth/login/", userInfo);
        this.dispatch("setToken", res.data.token);
        this.dispatch("setUser", JSON.stringify(res.data.user));
        state.myAxios = axios.create({
          baseURL: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_BACK_HOST}:${process.env.VUE_APP_PORT}`,
          headers: {
            "Content-Type": "application/json",
            common: {
              Authorization: "Bearer " + res.data.token,
            },
          },
        });
      } catch (error) {
        return error;
      }
    },

    async cargaInicial({ state }) {
      await this.dispatch("setMaquinas");
      this.dispatch("createConnection");
    },

    logout({ state }) {
      state.user = {};
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      router.push({ path: "login" });
    },
    async setMachine({ commit, state }, payload) {
      let maquina = state.maquinas.find((e) => e.maquina == payload);
      if (maquina) {
        console.log("SetMachine", maquina)
        state.maquina = maquina;
        if (maquina.maquina == "moldeo" || maquina.maquina == "macheria") {
          try {
            const res = await state.myAxios.get(`piezas/${maquina.id_maquina}`);
            state.piezasMaquina = res.data;
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        console.log("No encuentro ", payload)
        state.maquina = {};
      }
    },

    setTab({ commit, state }, payload) {
      state.tab = payload;
    },
    async setMaquinas({ state }) {
      try {
        const res = await state.myAxios.get("maquinas/");
        console.log("setMaquinas", res)
        state.maquinas = res.data;
        this.dispatch("setMachine", "desmoldeo");
      } catch (e) {
        console.log("ERROR: ", e);
      }
    },
    setFechaInicio({ state }, fecha) {
      state.fechaInicio = fecha;
    },
    setFechaFin({ state }, fecha) {
      state.fechaFin = fecha;
    },
    setShowChart({ state }, payload) {
      state.graficoTiempoReal = payload;
    },
    setVariableEnGrafica({ state }, payload) {
      state.variableEnGrafica = payload;
    },
    limpiarGrafico({ state }) {
      this.dispatch("setVariableEnGrafica", null);
      state.labelsParaGrafico = [];
      state.datasetsParaGrafico[0].data = [];
    },

    ////    API    ////
    // Obtener el estado de conexión de una máquina específica
    async getConnectionLossNotification({ state }) {
      try {
        const response = await state.myAxios.get(`notificaciones/connection-loss-notifications`);
        return response.data;
      } catch (error) {
        console.error(`Error al obtener la notificación de conexión para la máquina :`, error);
        throw error;
      }
    },

    // Actualizar el estado de conexión de una máquina específica
    async updateConnectionLossNotification({ state }, payload) {
      const { id, ...data} = payload;
      try {
        const response = await state.myAxios.put(`notificaciones/connection-loss-notifications/${id}`,data);
        console.log(response);
        return response.data;
      } catch (error) {
        console.error(`Error al actualizar la notificación de conexión para la máquina ${id}:`, error);
        throw error;
      }
    },
    async getVariablesMaquina({state}, payload ) {
      const{maquina, ...data} = payload;
      console.log("payload", payload); // Para depurar lo que se recibe
      
      try {
        const response = await state.myAxios.get(`hornos/horno/variables/${maquina}`);
        console.log("response", response);
        return response;
      } catch (error) {
        console.error('Error al obtener las variables:', error);
        throw error;
      }
    },

    async getMaquinasYVariables({state}) {
      try {
        const response = await state.myAxios.get(`maquinas`);
        console.log("response", response);
        return response;
      } catch (error) {
        console.error('Error al obtener las variables:', error);
        throw error;
      }
    },

    async getNotificaciones({state}, payload){
      return (
        await state.myAxios.get(`notificaciones`)
      )
    },
    async postNotificaciones({state}, payload){
      return (
        await state.myAxios.post(`notificaciones`, payload)
      )
    },
    async updateNotificacion({ state }, payload) {
      const { id, ...data } = payload; 
      return await state.myAxios.put(`notificaciones/${id}`, data);
    },

    async deleteNotificacion({ state }, id) {
      return await state.myAxios.delete(`notificaciones/${id}`);
    },

    getHistoricos({ state }, payload) {
      return state.myAxios.get(`historicos/${payload.id_maquina}`, {
        params: payload,
      });
    },
    getVariablesEnCiclo({ state }, payload) {
      return state.myAxios.get(`variables/ciclo/${payload.id_ciclo}`);
    },

    getTotalHistoricosCiclo({ state }, payload) {
      return state.myAxios.get(`historicos/total`, { params: payload });
    },

    // async getHistoricosAcumulados({ state }, payload) {
    async getHistoricosAcumulados({ state, commit }, payload) {
      // Si ya existe una petición en curso, la cancelamos
      if (state.abortController) {
        console.log("ABORTANDO ANTERIOR!!!")
        state.abortController.abort();
      }
  
      // Crear un nuevo AbortController
      const abortController = new AbortController();
      commit("SET_ABORT_CONTROLLER", abortController);
  
      try {
        console.log("INTENTANDO CONECTAR")
        let response;


        // if(process.env.VUE_APP_VERSION_ACUMULADO==1) {
        if(state.versionAcumulado==2) {
          console.log("CLARO QUE ES DOS")
            response = await state.myAxiosAcumulado.get(`acumulados/minutos`, {
            params: payload,
            signal: abortController.signal, // Asociamos la señal de aborto
          });
          console.log("ha terminado el await!!!")
        } else {
            console.log("ES UNO")
            response = await state.myAxios.get('historicos/acumulados1', {
              params: payload,
              signal: abortController.signal, // Asociamos la señal de aborto
            });
        }

       
        console.log("YA HA TERMINADO", response)
  
        return response?.data;
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Petición cancelada");
        } else {
          console.error("Error en la petición", error);
        }
        return null;
      }
    },

    async getHistoricosProcesados({ state }, payload) {
      return (
        await state.myAxios.get(`historicos/procesados`, {
          params: payload,
        })
      )?.data;
    },

    getAlarmasActivas({ state }) {
      return state.myAxios.get(`alarmas/active`);
    },
    getHistoricoAlarmas({ state }, payload) {
      return state.myAxios.get(`alarmas/history/`, { params: payload });
    },

    async actionGetAlarmasActivas({ state }) {
      const res = await state.myAxios.get(`alarmas/active`);
      state.alarmasActivas = res.data;
    },

    SET_ACCUMULATIVE_VERSION({state},valor) {
      state.versionAcumulado = valor;
    },

    // nodered

    createConnection({ state }) {
      const { ...options } = state.connection;
      const connectUrl = `${process.env.VUE_APP_MQTT_PROTOCOL}://${process.env.VUE_APP_MQTT_HOST}:${process.env.VUE_APP_MQTT_PORT}`;

      try {
        state.client = mqtt.connect(connectUrl, options);
      } catch (error) {
        console.log("mqtt.connect error", error);
      }

      state.client.on("connect", () => {
        console.log("Connection succeeded!");
        this.dispatch("doSubscribe", "ultimaLecturaDesmoldeo");
        this.dispatch("doSubscribe", "ultimaLecturaMacheria");
        this.dispatch("doSubscribe", "ultimaLecturaMoldeo");
        this.dispatch("doSubscribe", "desmoldeo");
        //this.dispatch('doSubscribe','DESMOLDEO_PRUEBAS')
        this.dispatch("doSubscribe", "moldeo");
        this.dispatch("doSubscribe", "macheria");
        this.dispatch("doSubscribe", "alarmas_activas");
        this.dispatch("doSubscribe", "desmoldeo_parrilla_1");
        this.dispatch("doSubscribe", "desmoldeo_parrilla_2");
        this.dispatch("doSubscribe", "imf_nave_2");
        this.dispatch("doSubscribe", "hornos1y2");
        this.dispatch("doSubscribe", "horno1");
        this.dispatch("doSubscribe", "horno2");


        state.client.on("message", async (topic, message) => {
          const text = new TextDecoder().decode(message);
          const maquinas_posibles = Object.keys(state.datos_maquina);
          if (topic == "alarmas_activas") {
            this.dispatch("actionGetAlarmasActivas");
          }
          if (maquinas_posibles.includes(topic)) {
            let current_machine = state.maquinas.find(
              (m) => m.maquina == topic
            );
            if (!current_machine) return;
            const current_data = JSON.parse(text);
            if (topic == "desmoldeo") {
              state.ultima_lectura_desmoldeo = moment(
                current_data.fecha_lectura
              ).format("YYYY-MM-DD HH:mm:ss");
            } else if (topic == "macheria") {
              state.ultima_lectura_macheria = moment(
                current_data.fecha_lectura
              ).format("YYYY-MM-DD HH:mm:ss");
              current_machine.estado = current_data.estado; // la variable que indica si el ciclo esta en marcha o no
              current_machine.pieza = current_data.referencia; // la variable que indica la pieza que se esta usando
            } else if (topic == "moldeo") {
              state.ultima_lectura_moldeo = moment(
                current_data.fecha_lectura
              ).format("YYYY-MM-DD HH:mm:ss");
              current_machine.estado = current_data.estado; // la variable que indica si el ciclo esta en marcha o no
              current_machine.pieza = current_data.referencia; // la variable que indica la pieza que se esta usando
            }
            else if(topic == "imf_nave_2"){
              state.ultima_lectura_imf_nave_2 = moment(
                current_data.fecha_lectura
              ).format("YYYY-MM-DD HH:mm:ss");
              current_machine.estado =  current_data.estado;
            }
            else if(topic == "hornos1y2"){
              state.ultima_lectura_hornos1y2 = moment(
                current_data.fecha_lectura
              ).format("YYYY-MM-DD HH:mm:ss");
              current_machine.estado =  current_data.estado;
            }
          
            
            current_machine.variables.map((element) => {
              const a = current_data.datos.find(
                (cd) => cd.memoria == element.memoria
              );
              element["valor"] = a ? a.valor : null;
              element["fecha_lectura"] = a
                ? moment(a.fecha_lectura).format("YYYY-MM-DD HH:mm:ss")
                : null;
              element["topic"] = topic;
              if (a) {
                if ("memoria" in a) {
                  element["memoria"] = a.memoria;
                }
              }

              //Datos para el gráfico en tiempo real
              if (element.id_variable == state.variableEnGrafica) {
                let valor_applica = null;
                try {
                  let valor_actual = element.valor * element.escala;
                  valor_applica = valor_actual.toFixed(element.decimales);
                } catch (error) {
                  valor_applica = `err: ${element.valor}`;
                }
                state.datasetsParaGrafico[0].data.push(valor_applica);
                state.datasetsParaGrafico[0].label = element.variable;
                state.labelsParaGrafico.push(element["fecha_lectura"]);
              }

              return element;
            });
            state.datos_maquina[topic] = current_machine.variables;
            state.datos_maquina[topic].splice();
          }

          /////////// PARRILLAS ///////////

          if ("desmoldeo_parrilla_1" == topic) {
            const agrupado = {};

            const current_data = JSON.parse(text);
            const datos = current_data.datos;

            datos.forEach((item) => {
              agrupado[item.memoria] = item.valor;
            });

            state.datos_parrillas_1 = agrupado;
          } else if ("desmoldeo_parrilla_2" == topic) {
            const agrupado2 = {};

            const current_data = JSON.parse(text);
            const datos = JSON.parse(JSON.stringify(current_data.datos));

            datos.forEach((item) => {
              agrupado2[item.memoria] = item.valor;
            });

            state.datos_parrillas_2 = agrupado2;
          }
        });
      });
      state.client.on("error", (error) => {
        console.log("Connection failed", error);
      });
    },
    doSubscribe({ state }, topic) {
      const { qos } = state.subscription;
      state.client.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
      });
    },
    
    doPublish({ state }, { topic, message, qos = 0 }) {
      if (!state.client) {
        console.error("MQTT client is not initialized.");
        return;
      }
      
      state.client.publish(topic, message, { qos }, (error) => {
        if (error) {
          console.error("Failed to publish message:", error);
        } 
      });
    },
    
  },
  modules: { utils },
});
